import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL;

export default function LegalPubblica({ tipo = "privacy" }) {
  const { rid } = useParams();
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch(`${API}/api/public/legal/${rid}?tipo=${tipo}`)
      .then(async (r) => {
        if (!r.ok) throw new Error();
        setDoc(await r.json());
      })
      .catch(() => setError(true));
  }, [rid, tipo]);

  const titolo = tipo === "cookie" ? "Cookie Policy" : tipo === "marketing" ? "Consenso Marketing" : "Privacy Policy";

  return (
    <div className="min-h-screen bg-zinc-50 py-10 px-4" data-testid="legal-public-page">
      <div className="max-w-2xl mx-auto bg-white border border-zinc-200 rounded-xl p-6 sm:p-8">
        {error && <p className="text-sm text-zinc-500">Documento non disponibile.</p>}
        {!error && !doc && <p className="text-sm text-zinc-400">Caricamento...</p>}
        {doc && (
          <>
            <p className="text-xs uppercase tracking-wider text-zinc-400 font-semibold">{doc.ristorante}</p>
            <h1 className="font-display text-2xl font-bold text-zinc-900 mt-1 mb-4" data-testid="legal-title">{titolo}</h1>
            {doc.bozza && (
              <div className="mb-4 text-[11px] bg-amber-50 border border-amber-200 text-amber-800 rounded-md px-3 py-2" data-testid="legal-bozza">
                Bozza standard in attesa di personalizzazione da parte del titolare.
              </div>
            )}
            <div className="text-sm text-zinc-700 leading-relaxed whitespace-pre-wrap" data-testid="legal-text">{doc.testo}</div>
          </>
        )}
      </div>
    </div>
  );
}
